<template>
    <v-container fluid>
        <div class="modal-padding">
            <v-row>
                <v-col cols="12" sm="12" class="zero-top test-view">
                    <div class="mx-auto">
                        <!-- <CommonInstructionsContent /> -->

                        <div>
                            <div class="mtb-5">Daily subscription change for {{getSubscriptionData(data) && getSubscriptionData(data).current_target_exam ?getSubscriptionData(data).current_target_exam.name:""}}: {{getSubscriptionData(data) && getSubscriptionData(data).current_target_exam ? "₹ " +getSubscriptionData(data).current_target_exam.daily_subscription_charge:""}}</div>
                            <div class="mtb-5">Number of days of  {{getSubscriptionData(data) && getSubscriptionData(data).current_target_exam ?getSubscriptionData(data).current_target_exam.name:""}} subscription Remaining:  {{getSubscriptionData(data) && getSubscriptionData(data).current_target_exam ?getSubscriptionData(data).current_target_exam.days_to_expiry:""}}</div>
                            <div class="mtb-5">Total subscription credit:  {{getSubscriptionData(data) && getSubscriptionData(data).current_target_exam ? "₹ " +getSubscriptionData(data).current_target_exam.subscription_price:""}}</div>
                            <div class="mtb-5">Daily subscription change for {{getSubscriptionData(data) && getSubscriptionData(data).new_target_exam ?getSubscriptionData(data).new_target_exam.name:""}}: {{getSubscriptionData(data)&& getSubscriptionData(data).new_target_exam ? "₹ " +getSubscriptionData(data).new_target_exam.daily_subscription_charge:""}}</div>
                            <div class="mtb-5">Number of days of  {{getSubscriptionData(data) && getSubscriptionData(data).current_target_exam ?getSubscriptionData(data).current_target_exam.name:""}} subscription obtained:  {{getSubscriptionData(data) && getSubscriptionData(data).new_target_exam ?getSubscriptionData(data).new_target_exam.days_to_expiry:""}}</div>
                            <div class="mtb-5">New subscription expiry date for ( {{getSubscriptionData(data) && getSubscriptionData(data).new_target_exam ?getSubscriptionData(data).new_target_exam.name:""}}): <b>{{getSubsciptionDate()}}</b></div>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="btn-center-align">
                        <v-btn @click="onClose({...data, status:false})" class="cust-btn" color="primary">Close</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>
<script>
import moment from 'moment'
import constants from '../../utils/constants'


export default {
    name: 'InformationPopup',
    props: ['data','status','onClose'],
    data() {
        return {
        }
    },   
    methods:{
        getSubsciptionDate(){
             return this.data && this.data.subscription && this.data.subscription.impact_price_details && this.data.subscription.impact_price_details.new_target_exam ?moment(this.data.subscription.impact_price_details.new_target_exam.expiry_date).format(constants.DATE_FORMATS.DISPLAY_DATE):""
        },
        getSubscriptionData(data){
            return data.subscription && data.subscription.impact_price_details ? data.subscription.impact_price_details : ""
        }
    },
}
</script>
